import { render, staticRenderFns } from "./ReportProfit.vue?vue&type=template&id=21baff15&scoped=true&"
import script from "./ReportProfit.vue?vue&type=script&lang=js&"
export * from "./ReportProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21baff15",
  null
  
)

export default component.exports